<template>

    <div v-if="isVisible" class="modal-overlay modal">
        <div class="modal-content w-50 p-0">

            <form @submit.prevent="update()">
                <div class="modal-header p-3">
                    <h5 class="mb-0">Editar Plano</h5>
                    <i class="ri-close-line cursor-pointer" @click="closeModal"></i>
                </div>

                <div class="modal-body p-3 overflow-auto " style="max-height: 70vh;">

                    <div class="mb-2 d-flex gap-2">

                        <div class="flex-1">
                            <InputField :required="true" label="Nome do plano *" type="text"
                                placeHolder="Digite aqui o nome da plano *" v-model="newPlano.nome" />
                        </div>

                    </div>

                    <div class="mb-2 d-flex gap-2">
                        <div class="flex-1">
                            <TextAreaField :required="true" label="Descrição *"
                                placeHolder="Digite aqui uma descrição sobre esse plano *" v-model="newPlano.descricao">
                            </TextAreaField>
                        </div>
                    </div>

                    <div class="mb-3 mt-3 d-flex gap-2 flex-column">
                        <div class="flex-1">

                            <SelectField classLabel="form-label mb-0" label="Parcerias" labelOption="nome"
                                :options="parceriasStore.parcerias" placeHolder="Escolha as Parcerias" valueProp="id"
                                :canClear="true" v-model="newPlano.parcerias" :multiple="true" />

                        </div>
                    </div>

                    <div class="mb-3 mt-3 d-flex gap-2 flex-column">
                        <div class="flex-1">

                            <SelectField classLabel="form-label mb-0" label="Módulos *" labelOption="nome"
                                :options="modulosstore.modulos" placeHolder="Escolha os módulos *" valueProp="id"
                                :canClear="true" :required="true" v-model="newPlano.modulos" :multiple="true" />


                        </div>

                        <template v-if="newPlano.modulos.length">

                            <div>
                                <table class="table table-bordered mb-0">

                                    <thead>
                                        <tr>
                                            <th>Descrição</th>
                                            <th>Valor</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="modulo in newPlano.modulos" :key="modulo">
                                            <td>{{ getModuloName(modulo) }}</td>
                                            <td>{{ $moneyConvert.convert(getModuloValor(modulo)) }}</td>
                                        </tr>
                                    </tbody>

                                    <tfoot>
                                        <tr>
                                            <td>Valor sugerido</td>
                                            <td>{{ $moneyConvert.convert(getValorSurgeridoModulos()) }}</td>
                                        </tr>
                                    </tfoot>

                                </table>
                            </div>

                        </template>
                    </div>

                    <div class="mb-0 d-flex gap-2">
                        <div class="flex-1">
                            <InputField :required="true" label="Valor *" type="text"
                                placeHolder="Digite aqui o valor de contratação desse plano ..."
                                v-model="newPlano.valor" maskType="money" />
                        </div>
                    </div>


                </div>

                <div class="modal-footer p-3">

                    <ButtonField @click="closeModal" size="small" text="Fechar" type="light"></ButtonField>

                    <ButtonField size="small" text="Salvar" type="success" :submit="true" :isLoading="isLoading"
                        :loadingText="'Atualizando plano'"></ButtonField>

                </div>
            </form>

        </div>
    </div>

</template>

<script>
import { useModulosStore } from '@/stores/modulos';
import { useParceriasStore } from '@/stores/parcerias';

import { usePlanosStore } from '@/stores/planos';
import { toast } from 'vue3-toastify'

export default {
    props: {
        isVisible: {
            type: Boolean,
            default: false
        },
        plano: {
            type: Object
        },
    },
    emits: ['close'],
    data() {
        return {
            planosStore: usePlanosStore(),
            modulosstore: useModulosStore(),
            parceriasStore: useParceriasStore(),
            newPlano: {},
            isLoading: false
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        getModuloName(id) {
            return this.modulosstore.modulos.find(m => m.id == id).nome
        },
        getModuloValor(id) {
            return this.modulosstore.modulos.find(m => m.id == id).valor
        },
        getValorSurgeridoModulos() {
            let valor = 0
            for (const modulo of this.newPlano.modulos) {
                valor += this.getModuloValor(modulo)
            }
            return valor
        },
        async update() {

            this.isLoading = true

            let valor = this.newPlano.valor
            if (typeof valor == 'string') {
                valor = valor.replace('R$ ', '')
                valor = valor.replace('.', '')
                valor = valor.replace(',', '.')
                valor = parseFloat(valor)
            }
            this.newPlano.valor = valor

            const result = await this.planosStore.update(this.newPlano)

            this.isLoading = false

            if (result.status) {
                toast.success("Plano editado com sucesso")
                this.closeModal()
                this.planosStore.get()
            } else {
                toast.error(result.message)
            }

        }
    },
    watch: {
        'plano': {
            handler(planoNew) {

                console.log(planoNew)
                if(!planoNew.id) return

                if(typeof planoNew.valor != 'string') planoNew.valor = planoNew.valor.toString()

                if(!planoNew.valor.includes('.')) 
                {
                    planoNew.valor = parseFloat(planoNew.valor).toFixed(2).replace('.',',')
                }else{
                    planoNew.valor = planoNew.valor.replace('.',',')
                }
                
                this.newPlano = { ...planoNew }

            },
            immediate: true
        }
    },
    mounted() {
        this.modulosstore.get()
        this.parceriasStore.get()
    }
}
</script>